import { render } from "./Camera.vue?vue&type=template&id=6be2dbf9"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=6be2dbf9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__